import React from 'react';
import { Box, Typography } from '@mui/material';
import { cardSx, colors, typography } from '../constants';

/** KPI tile: a label, a large value and an optional sub-line. */
export default function StatCard({ label, value, sub, valueColor, sx }) {
  return (
    <Box sx={{ ...cardSx, p: 2, height: '100%', ...sx }}>
      <Typography
        sx={{
          fontSize: typography.caption,
          fontWeight: 600,
          color: colors.mutedForeground,
        }}
      >
        {label}
      </Typography>
      <Typography
        sx={{
          mt: 0.5,
          fontSize: typography.display,
          fontWeight: 800,
          lineHeight: 1.15,
          color: valueColor ?? colors.foreground,
        }}
      >
        {value}
      </Typography>
      {sub ? (
        <Typography
          sx={{
            mt: 0.25,
            fontSize: typography.caption,
            color: colors.faint,
          }}
        >
          {sub}
        </Typography>
      ) : null}
    </Box>
  );
}

/** Smaller boxed figure used inside expanded rows. */
export function MiniStat({ label, value, valueColor, children, sx }) {
  return (
    <Box
      sx={{
        flex: 1,
        minWidth: 0,
        backgroundColor: colors.muted,
        borderRadius: 2,
        p: 1.25,
        ...sx,
      }}
    >
      <Typography
        sx={{
          fontSize: typography.caption,
          color: colors.mutedForeground,
          fontWeight: 600,
        }}
      >
        {label}
      </Typography>
      {children ?? (
        <Typography
          sx={{
            fontSize: typography.emphasis,
            fontWeight: 800,
            color: valueColor ?? colors.foreground,
          }}
        >
          {value}
        </Typography>
      )}
    </Box>
  );
}
